import React, { useEffect, useState, useMemo } from 'react'
import { notification } from 'antd'
import { useLocation, useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import heWinPixel from '@api/hernest/winPixel_m.bak'
import { getSuccessOrderInfo } from '@api/home/shopCart/statement/action'
import { routesPath } from '@api/home/utils'
import { success, triggleLogin } from '@api/home/store/slice/loginSlice'
import { getSearchParams, isMobileProject } from '@utils'
import useGlobalEvent, { dispatchGlobalEvent } from '@hooks/useGlobalEvent'
import winPixel from '@utils/winPixel'

export const paymethodIcon = {
  ['oceanpay_creditcard']: require(
    `@/${process.env.template}/src/assets/icon/creditcard.svg?url`
  ),
  ['paypal']: require(
    `@/${process.env.template}/src/assets/icon/paypal.svg?url`
  ),
  ['payoneer_creditcard']: require(
    `@/${process.env.template}/src/assets/icon/creditcard.svg?url`
  ),
  ['oceanpay_klarna']: require(
    `@/${process.env.template}/src/assets/imgs/klarna.png?url`
  )
}

// 获取url 参数
export const getSuccessOrderParams = (href) => {
  const searchData = href?.split('?')?.[1] || ''
  const searchParams = new URLSearchParams(searchData)
  const urlParams = Object.fromEntries(searchParams.entries())
  return urlParams || {}
}

/**
 * @description: 2024-10-23新增异步等待交互
 * @param {*} siteName 站点名称
 * @return {*}
 */

export const useStatement = (props, siteName = 'yitahome') => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const isLogin = useSelector((state: any) => state.app.isLogin)
  const newParams = getSearchParams(location.search, ['order_token'] as const)

  // 首次ssr获取数据
  const { pageData, isLoading, isError, err } = props
  console.info('下单成功页数据:', pageData)
  const [OrderData, setOrderData] = useState({
    shippingAddress: {},
    billingAddress: {}, // 数据兼容
    ...pageData
  })
  const waitSeconds = Number(OrderData.waitSeconds) || 0
  const ssrRecData = OrderData.recData || {}
  const [timeRemaining, setTimeRemaining] = useState(waitSeconds)
  const [asyncOrder, setAsyncOrder] = useState(false)
  const [asyncStartLoading, setAsyncStartLoading] = useState(false)
  const [errorLoading, setErrorLoading] = useState(false)

  // 二次调用接口
  const asyncFetchOrder = () => {
    if (!newParams.order_token) return
    setAsyncStartLoading(true)
    getSuccessOrderInfo({ orderToken: newParams.order_token })
      .then((resData) => {
        // 数据兼容
        setOrderData({ shippingAddress: {}, billingAddress: {}, ...resData })
      })
      .finally(() => {
        setAsyncStartLoading(false)
      })
  }

  // 异步等待倒计时
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null
    if (timeRemaining > 0) {
      timer = setInterval(() => {
        if (timeRemaining > 0) {
          setAsyncOrder(true)
          setTimeRemaining((prevTime) => prevTime - 1)
        } else {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    } else {
      // // 开始异步时则发起二次请求
      if (asyncOrder && timeRemaining === 0) {
        setAsyncOrder(false)
        asyncFetchOrder()
      }
    }
    // 清除定时器
    return () => timer && clearInterval(timer)
  }, [timeRemaining])

  // 没有token则跳转首页
  useEffect(() => {
    if (!newParams.order_token) {
      navigate(routesPath.home)
    }
  }, [])

  const joinNow = () => {
    // window.open('https://www.facebook.com/groups/hernesthomedecor')
    window.open('https://bit.ly/3Olexpc')
  }

  const toInvoiceUrl = () => {
    window.open(OrderData.invoiceUrl, '_self')
  }

  const handleLogin = () => {
    if (isLogin) return
    if (isMobileProject) {
      const backUrl = `${location.pathname}${location.search}`
      navigate(`/login?backUrl=${backUrl}`)
    } else {
      dispatch(triggleLogin(true))
    }
    window?.fa.en('click', {
      position: 'statement_page',
      name: 'click_sign_in'
    })
  }

  // 推荐位的ids
  const skuIds = useMemo(
    () => (OrderData?.ordersProducts || []).map((item) => item.skuId),
    [OrderData.ordersProducts]
  )

  // 埋点处理
  useEffect(() => {
    if (OrderData?.ordersProducts?.length) {
      switch (siteName) {
        case 'yitahome':
          winPixel.purchase(
            OrderData,
            100973,
            [
              'AW-557240052/QnXwCIGW-oAYEPSd24kC',
              'AW-11323451663/yITkCLGVq9wYEI_SuJcq',
              'AW-11327320617/hJXzCNv8qPIYEKnkpJkq'
            ],
            '654dc58584c2bc3c6d0f3735',
            '259103656'
          )
          break

        case 'hernest':
          heWinPixel.purchase(OrderData)
          break
      }
    }
  }, [JSON.stringify(OrderData?.ordersProducts)])

  // 页面异常跳转处理
  useEffect(() => {
    if ([200].includes(OrderData?.code)) return
    if ([306, 307].includes(OrderData?.code)) {
      setErrorLoading(true)
      setTimeout(() => {
        window.location.href = OrderData?.code === 306 ? '/' : '/checkout'
        setErrorLoading(false)
      }, 1000)
    } else {
      notification.error({
        message: 'Failure!',
        description: `${OrderData?.message}`,
        duration: 5
      })
    }
  }, [OrderData?.code])

  return {
    OrderData,
    joinNow,
    isError,
    err,
    isLoading,
    navigate,
    toInvoiceUrl,
    isLogin,
    handleLogin,
    timeRemaining,
    asyncStartLoading,
    errorLoading,
    skuIds,
    ssrRecData
  }
}
